function round(value, exp) {
  if (typeof exp === 'undefined' || +exp === 0)
    return Math.round(value);

  value = +value;
  exp = +exp;

  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
    return NaN;

  // Shift
  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}

$(document).ready(function() {

/*** grid-template start ***/
 
	
  $('.fancybox-popup-product-images-right').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    variableWidth: true,
    slide: '.fancybox-popup-product-images-inner',
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
      {
        breakpoint: 461,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

$('.fancybox-popup-product-images-right').on('afterChange', function(event, slick, currentSlide, nextSlide){
   var id = $(".fancybox-popup-product-images-right .fancybox-popup-product-images-inner[data-slick-index='"+currentSlide+"']").attr("id");
    $(".fancybox-popup-product-images .fancybox-popup-product-images-inner").removeClass('active');
     $(".fancybox-popup-product-images .fancybox-popup-product-images-inner[id='"+id+"']").addClass("active");
});
  
  $('.grid-format-image-slider-wrapper').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 900,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    slide: '.grid-format-image-slider-items',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 900,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
$(window).resize(function(){
  $('.grid-image-product-template .product-gallery.mobile_view img').css('height', '100%');
  // if(window.innerWidth > 720){
  //   location.reload();
  // }
});
if(window.innerWidth > 720){
  var colorValue = $(".swatches-variant-images-square.product-options-style-select .cstm-option-values .option-value.option-selected").find('.option-value-input').attr('value');
   var go_no = $('.grid-format-image-slider-wrapper .grid-format-image-slider-items[data-variant-color="'+colorValue+'"]').attr('data-slick-index');
    $('.grid-format-image-slider-wrapper').slick('slickGoTo', go_no);
  
$("body").on('change',".swatches-variant-images-square.product-options-style-select .cstm-option-values .option-value", function(){
    // e.preventDefault();
   //$('.cstm-option-values .option-value input').attr('checked', false);
  // $(this).find('.option-value-input').attr('checked', true);

   var colorValue = $(this).find('.option-value-input').attr('value');
    console.log(colorValue)
    var go_no = $('.grid-format-image-slider-wrapper .grid-format-image-slider-items[data-variant-color="'+colorValue+'"]').attr('data-slick-index');
    $('.grid-format-image-slider-wrapper').slick('slickGoTo', go_no);
    
});
  
function popup_image_delay(){
  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner").css('opacity', '0');
   $(".fancybox-popup-product-images-right").css('background', '#f0f5f6');
}
function popup_delay(){
  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner").css('opacity', '1');
}
  
$(document).on('click', '.grid-format-image-container img', function(e){
    e.preventDefault();
    popup_image_delay();
   $('.fancybox-popup').css('display', 'block');
    $("body").addClass("custom-newsletter-popup");
    $('.site-header-wrapper.site-header--sticky').css('position', 'fixed');
    // $('.site-header-wrapper').css('z-index', 0);
    // $(".fancybox-popup-product-images .fancybox-popup-product-images-inner:first-child").addClass("active");
    
    let img_src = $(this).attr("data-zoom");
    let index2 =  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner[data-src='"+img_src+"']").attr("data-slick-index");
    $('.fancybox-popup-product-images-right').slick('slickGoTo',index2);
    setTimeout(popup_delay, 500);
    // let id = $(this).attr("id");
    //  let index =  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner[id='"+id+"']").attr("data-slick-index");
    //  $('.fancybox-popup-product-images-right').slick('slickGoTo',index);
});

$("body").on("click",".fancybox-popup-product-images .fancybox-popup-product-images-inner" ,function(){
     popup_image_delay();
     $(".fancybox-popup-product-images .fancybox-popup-product-images-inner").removeClass("active");
     $(this).addClass("active");
     let id = $(this).attr("id");
     let index =  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner[id='"+id+"']").attr("data-slick-index");
     $('.fancybox-popup-product-images-right').slick('slickGoTo',index);
     setTimeout(popup_delay, 600);
 });

$(document).on("click", ".popup__close", function () {  
    // $('.site-header-wrapper.site-header--sticky').css('position', 'sticky');
    // $('..site-header-wrapper').css('z-index', 1);
      $(".fancybox-popup").css("display", "none");
          $("body").removeClass("custom-newsletter-popup");
    //       $("html").css("overflow-x", "none");
    // $('body').css('overflow','auto')
      });
}
$('body').on('click', '.fancybox-popup-product-images-wrapper', function(e) {
  if (e.target !== this)
    return;
  $(".fancybox-popup").css("display", "none");
  $("body").removeClass("custom-newsletter-popup");
});
  
/*** grid-template end ***/
  
  
/* Cart Upsell 25% manually with script start */
$(".main-content-div").each(function(item){
let get_price = $(this).find($('.upsell-product-prices .pro-price')).text();
    let split_price = get_price.replace('$', '');
    let persent_data = 25 / 100 * parseFloat(split_price);
    let final_price = parseFloat(split_price) - parseFloat(persent_data);
    $(this).find($(".discounted-pro-price")).text("$" + round(final_price,2));
  
});
  
/* Cart Upsell 25% manually with script end */
  
/** up-sell cart page start **/
  $(".cstm-data").click(function(){
    var editid = $(this).attr("data-vId");
    var varimg = $(this).attr("data-src")
   // $(this).parents(".main-content-div").find(".change-img").removeClass("active-img");
        $(this).parents(".main-content-div").find(".change-img").addClass("active-img");
    // $(this).parents(".cstm-1main-product").find(".change-img").val(varimg);
    $(this).parents(".main-content-div").find(".change-img").attr("src", varimg);
    $('.cstm-data').removeClass("active-cstm");
    $(this).addClass("active-cstm");
     $(this).parents(".adding-prdct").find(".variantsel").val(editid);
   
  });

  $('.free-product-varient').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
  });
  
   $('.upsell_items_main').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
            {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
/** up-sell cart page end **/
  
  /*** shogun form field reset after submit start ***/
      // const formToReset = document.querySelector('.custom-page-contact-form .shogun-form-box');
      // formToReset.addEventListener('submit', (e) => {
      //    e.preventDefault();
      //    formToReset.reset();
      // });
  /*** shogun form field reset after submit end ***/
  
    $(document).on('click','body *',function(){
     $('.limoniapps-notification.closeable').removeClass('minimized');
    
});

 $(document).on("click", ".header_popup_cart", function(e){
   $(".limoniapps-notification.closeable").css("display", "none");

});
  $(document).on("click", ".limoniapps-notification-buttons", function(){
    $(this).parents().find(".limoniapps-notification").css("display","none");
});
  
  $('.contributors-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 861,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.gallery-navigation--scroller').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    slide: '.product-gallery--slide',
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
      {
        breakpoint: 461,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 401,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
  setTimeout(function(){
    $('.productitem--swatches-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slide: 'label',
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      centerMode: false,
      centerPadding: '25px',
      responsive: [
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
  },1000);
  $('.testimonials-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
//   $('.productitem--swatches-slider').slick('setPosition');
//   $(".productitem--swatches-slider")[0].slick.setPosition();
  
  $("button.dropdown-toggle").click(function() {
    $(".dropdown-options").hide();
    $(this).parent('.custom-drop-down').find('.dropdown-options').toggle();
  });

  //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
  $(".dropdown-options ul li a").click(function() {
    var text = $(this).html();
    $(this).parents('.custom-drop-down').find("button.dropdown-toggle span").html(text);
    $(".dropdown-options").hide();
  }); 


  //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("custom-drop-down"))
      $(".dropdown-options").hide();
  });

  $(".dropdown-options ul li").each(function(){
    if ($(this).hasClass('active')){      
      var text = $(this).find('a').html();
      $(this).parents('.custom-drop-down').find("button.dropdown-toggle span").html(text);
    }
  });
  $('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
      markup: '<div class="mfp-iframe-scaler">'+
      '<div class="mfp-close"></div>'+
      '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
      '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

      patterns: {
        youtube: {
          index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

          id: 'v=', // String that splits URL in a two parts, second part should be %id%
          // Or null - full URL will be returned
          // Or a function that should return %id%, for example:
          // id: function(url) { return 'parsed id'; }

          src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }

        // you may add here more sources

      },

      srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
    }
  });
  /* Product Qty Adjust Start */
  var $result=$('#product-quantity-input');
  var number= Number($('#product-quantity-input').val());
  var minQty = Number($('#product-quantity-input').attr('min'));
  var isDown=0;
  var delay=150;
  var nextTime=0;
  $(document).on('change','#product-quantity-input',function(e){
    number = Number($(this).val());
  });

  requestAnimationFrame(watcher);

  $('button.product-js-qty__adjust').on({ 'mousedown' : function(e){handleMouseDown(e);} });
  $('button.product-js-qty__adjust').on({ 'mouseup' : function(e){handleMouseUp(e);} });
  $('button.product-js-qty__adjust').on({ 'mouseout' : function(e){handleMouseUp(e);} });
  
  $('button.product-js-qty__adjust').on({ 'touchstart' : function(e){handleMouseDown(e);} });
  $('button.product-js-qty__adjust').on({ 'touchend' : function(e){handleMouseUp(e);} });


  function handleMouseDown(e){
    // tell the browser we're handling this event
    e.preventDefault();
    e.stopPropagation();

    // Put your mousedown stuff here
    isDown=(e.target.id=='qty__adjust--plus-id')?1:-1;
  }

  function handleMouseUp(e){
    // tell the browser we're handling this event
    e.preventDefault();
    e.stopPropagation();

    // Put your mouseup stuff here
    isDown=0;
  }

  function watcher(time){
    requestAnimationFrame(watcher);
    if(time<nextTime){return;}
    nextTime=time+delay;
    if(isDown!==0){
      if(isDown === -1){
        if(number > minQty){
          number+=isDown;
        }else{
          if($('.qty-error-msg-cls').length == 0){
            $('<p class="qty-error-msg-cls">You need to add minimum '+minQty+' qty</p>').insertBefore('.product-form--atc');
          }
        }
      }else{
        number+=isDown;
      }
      $result.val(number);
    }
  }
  $(document).on('click','.js-qty__adjust',function(){
    var qtyInput = $(this).parents('.js-qty__wrapper').find('.js-qty__num');
    var minValue = qtyInput.attr('min');
    var value = Number(qtyInput.val()), newValue;
    if($(this).hasClass('js-qty__adjust--minus')){
      var newValue = value - 1;
      if(newValue < minValue){
        if($(this).parents('.form-fields--qty').hasClass('product-form--atc-qty')){
          var newValue = value;
          if($('.qty-error-msg-cls').length == 0){
            $('<p class="qty-error-msg-cls">You need to add minimum '+minValue+' qty</p>').insertBefore('.product-form--atc');
          }
        }else{
          var newValue = 0;
        }
      }
    }
    if($(this).hasClass('js-qty__adjust--plus')){
      var newValue = value + 1;
      if(newValue >= minValue){
        $('.qty-error-msg-cls').remove();
      }
    }
    $(qtyInput).val(newValue);
    if($(this).hasClass('cart-qty__adjust')){
      //location.reload();
      //$('.cart-update-cls').trigger('click');
    }
  });
  /* Product Qty Adjust End */
  if($("#shopify-section-static-product-reviews").length > 0){
    $(".product-ratings-scroll").click(function() {
      var afterReviewSectionTop = Number($("#shopify-section-static-product-reviews").offset().top);
      $('html, body').delay(-1000).animate({
        scrollTop: afterReviewSectionTop
      }, 500);
    });
  }
});
function Slickcall(){
  $('.productitem--swatches-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slide: 'label',
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      centerMode: false,
      centerPadding: '25px',
      responsive: [
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
}
$(document).on('click','.utils-viewtoggle-button',function(){
  var viewType = $(this).data('collection-view');
  if(viewType == 'list-view'){
    $('.productitem--swatches-slider').slick('unslick');
  }else{
    Slickcall();
  }
});

$(document).on('change','.js-qty__num',function(){
  var CurrentValue = Number($(this).val());
  var minValue = Number($(this).attr('min'));
  var newValue = minValue;
  var QtyWraper = $(this).parents('.form-fields--qty').find('.js-qty__wrapper');
  if(CurrentValue < minValue){
    if($(this).parents('.form-fields--qty').hasClass('product-form--atc-qty')){
      newValue = minValue;
      if($('.qty-error-msg-cls').length == 0){
        $('<p class="qty-error-msg-cls">You need to add minimum '+minValue+' qty</p>').insertBefore('.product-form--atc');
      }
    }else{
      /*newValue = 0;*/
      if(CurrentValue == 0){
        newValue = 0;
        $(this).parents('.form-fields--qty').find('.qty-error-msg-cls').remove();
      }else{
        newValue = minValue;
        if($(this).parents('.form-fields--qty').find('.qty-error-msg-cls').length == 0){
          $('<p class="qty-error-msg-cls">You need to buy minimum '+minValue+' qty</p>').insertBefore(QtyWraper);
        }
      }
    }
  }else{
    newValue = CurrentValue;
    $('.qty-error-msg-cls').remove();
  }
  $(this).val(newValue);
});